import { FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_RESET } from '../constants';
import Requests from '../requests';

const ForgotPasswordService = {
  requestPasswordReset,
  resetPassword
};

async function requestPasswordReset(email, baseUrl) {
  return Requests.post(FORGOT_PASSWORD_REQUEST, { email, baseUrl });
}

async function resetPassword(token, newPassword) {
  return Requests.post(FORGOT_PASSWORD_RESET, { token, newPassword });
}

export default ForgotPasswordService; 